(() => {
  if (window.MOTTileSwatchSyncLoaded) return;
  window.MOTTileSwatchSyncLoaded = true;

  const syncRestoredSwatches = () => {
    document.querySelectorAll('[data-mot-tile]').forEach((tile) => {
      const checked = tile.querySelector('input[type="radio"][name^="tile-swatch-"]:checked');
      if (!checked || tile.dataset.motCurrentVariant === checked.dataset.variantId) return;
      checked.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  document.addEventListener('alpine:initialized', syncRestoredSwatches);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) requestAnimationFrame(syncRestoredSwatches);
  });
})();
